import { attachmentsApi } from './queries/attachments'
import { authApi } from './queries/auth'
import { cartApi } from './queries/cart'
import { claimRecordsApi } from './queries/claimRecords'
import { configApi } from './queries/config'
import { guestCustomerApi } from './queries/guestCustomer'
import { insurersApi } from './queries/insurers'
import { cancelClaimSlice } from './slices/cancelClaimSlice'
import { claimStatusSlice } from './slices/claimStatusSlice'
import { claimSubmitSlice } from './slices/claimSubmitSlice'
import { connectorSlice } from './slices/connectorSlice'
import { ctaSlice } from './slices/ctaSlice'
import { insuranceMemberSlice } from './slices/insuranceMemberSlice'
import { workflowSlice } from './slices/workflowSlice'

export const reducers = {
  [authApi.reducerPath]: authApi.reducer,
  [insurersApi.reducerPath]: insurersApi.reducer,
  [claimRecordsApi.reducerPath]: claimRecordsApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [attachmentsApi.reducerPath]: attachmentsApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [guestCustomerApi.reducerPath]: guestCustomerApi.reducer,
  [cancelClaimSlice.name]: cancelClaimSlice.reducer,
  [claimStatusSlice.name]: claimStatusSlice.reducer,
  [claimSubmitSlice.name]: claimSubmitSlice.reducer,
  [workflowSlice.name]: workflowSlice.reducer,
  [ctaSlice.name]: ctaSlice.reducer,
  [connectorSlice.name]: connectorSlice.reducer,
  [insuranceMemberSlice.name]: insuranceMemberSlice.reducer,
}
